import { render, staticRenderFns } from "./CollectionRepaymentIntentionPerformance.vue?vue&type=template&id=fdfb2f94&scoped=true&"
import script from "./CollectionRepaymentIntentionPerformance.vue?vue&type=script&lang=js&"
export * from "./CollectionRepaymentIntentionPerformance.vue?vue&type=script&lang=js&"
import style0 from "./CollectionRepaymentIntentionPerformance.vue?vue&type=style&index=0&id=fdfb2f94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfb2f94",
  null
  
)

export default component.exports